export default __webpack_public_path__ + "static/media/sp_accounts.089e193c.svg";